import React from 'react';
import './Cara.css';



class Cara extends React.Component {
   
    render () {
      return (
        <div className="cara jumbotron jumbotron-fluid">
            <h1>Cara Pembelian</h1>
            <div className="row">
                <div className="col-lg-2 col-md-5 col-5 border rounded shadow bg-light mx-auto">
                    <span><i className="fa fa-hand-pointer-o" aria-hidden="true"></i></span>
                    <h5>Pertama</h5>
                    <p>Pilih product yang tersedia</p>
                </div>
                <div className="col-lg-2 col-md-5 col-5 border rounded shadow bg-light mx-auto">
                    <span><i className="fa fa-list-ol" aria-hidden="true"></i></span>
                    <h5>Kedua</h5>
                    <p>Tetapkan kuantitasnya</p>
                </div>
                <div className="col-lg-2 col-md-5 col-5 border rounded shadow bg-light mx-auto">
                    <span><i className="fa fa-id-card-o" aria-hidden="true"></i></span>
                    <h5>Ketiga</h5>
                    <p>Mengisi identitas dan Menyelesaikan pemesanan</p>
                </div>
                <div className="col-lg-2 col-md-5 col-5 border rounded shadow bg-light mx-auto">
                    <span><i className="fa fa-whatsapp" aria-hidden="true"></i></span>
                    <h5>Keempat</h5>
                    <p>Tunggu follow up dari team kami untuk konfirmasi</p>
                </div>
                <div className="col-lg-2 col-md-5 col-5 border rounded shadow bg-light mx-auto">
                    <span><i className="fa fa-rocket" aria-hidden="true"></i></span>
                    <h5>Terakhir</h5>
                    <p>Pesanan diantar ke tempatmu</p>
                </div>
            </div>
        </div>
      );
    }
  }


export default Cara;
